import type { SVGProps } from "react";

export function IconBlackArrowRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M57.0045 32L12.5601 57V33.5H28.0601V30.5H12.5601V7L57.0045 32Z"
        fill="#23232C"
        stroke="#23232C"
        strokeWidth="1.5"
      />
    </svg>
  );
}
